// Owner-confirmed public identity. Uniqapps is a brand, not an asserted company type.
export const OPERATOR = Object.freeze({
    brand: 'Uniqapps',
    legalName: 'Safe Bank Security',
    controller: 'Benjamin F. Kristoffersen',
    email: 'Uniqapps@growdaily.fun',
});
